'use client'

import { cn } from '@/utilities/cn'
import React, { useEffect, useMemo, useRef, useState } from 'react'

import type { Props as MediaProps } from '../types'

export const Video: React.FC<MediaProps> = (props) => {
  const { className, onClick, resource, videoClassName } = props
  const videoRef = useRef<HTMLVideoElement>(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const onLoadedData = async () => {
      setIsReady(true)
      try {
        // Mute via ref (not JSX prop) so browsers allow autoplay
        // but user can freely unmute via native controls
        video.muted = true
        await video.play()
      } catch {
        // browser may block autoplay, user can use native controls
      }
    }

    video.addEventListener('loadeddata', onLoadedData)

    return () => {
      video.removeEventListener('loadeddata', onLoadedData)
    }
  }, [])

  const src = useMemo(() => {
    if (resource && typeof resource === 'object') {
      const { filename, url } = resource
      return url || `${process.env.NEXT_PUBLIC_SERVER_URL}/media/${filename}`
    }
    return ''
  }, [resource])

  if (!src) return null

  return (
    <div className={cn('relative h-full w-full', className)}>
      <video
        autoPlay
        className={cn('h-full w-full', videoClassName)}
        controls
        loop
        onClick={onClick}
        playsInline
        preload="metadata"
        ref={videoRef}
      >
        <source src={src} />
      </video>

      {!isReady && <div className="absolute inset-0 animate-pulse bg-black/10" />}
    </div>
  )
}
